import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { FacilityConfig, InstructorConfig } from 'src/environments/environment.interface';
import { EnvironmentService } from 'src/app/services/environment.service';
import { StudioService } from 'src/app/services/studio.service';
import { excludePartnerArtifacts } from 'src/app/models/studio/shared-schedule';

class InstructorInfo {
  Id: number = 0;
  FirstName: string = '';
  LastName: string = '';
  ImageUrl: string = '';
  IsPartnerArtifact?: boolean;
  PartnerHandle?: string;
  PartnerLocationId?: number | null;
  isPartnerArtifact?: boolean;
  partnerHandle?: string;
  partnerLocationId?: number | null;
  is_partner_artifact?: boolean;
  partner_handle?: string;
  partner_location_id?: number | null;
}

@Component({
  selector: 'app-instructors',
  templateUrl: './instructors.component.html',
  styleUrls: ['./instructors.component.scss']
})
export class InstructorsComponent implements OnInit, OnDestroy {

  settings: FacilityConfig;
  instructorConfig: InstructorConfig;
  carouselSlides: OwlOptions = {
    // items: 1,
    // nav: true,
    // margin: 10,
    loop: true,
    dots: false,
    autoplay: true,
    // smartSpeed: 500,
    // animateIn: 'fadeIn',
    // animateOut: 'fadeOut',
    autoplayHoverPause: true,
    // navText: [
    //   "<i class='fa-solid fa-chevron-left'></i>",
    //   "<i class='fa-solid fa-chevron-right'></i>"
    // ],
    responsive: {
      0:{
          items:1
      },
      600:{
          items:2
      },
      1000:{
          items:5
      }
    }
  };

  carouselSource: InstructorInfo[] = [];
  private readonly _unsubscribe: Subject<any> = new Subject();

  constructor(
    private _studioService: StudioService,
    private _environmentService: EnvironmentService
  ) { 
    this.settings = this._environmentService.getFacilityConfig();
    this.instructorConfig = this.settings.homePage.instructors;
  }

  ngOnInit(): void {
    if(this.instructorConfig.show == true) {
      this._studioService.getInstructorsPublic()
        .pipe(
          takeUntil(this._unsubscribe),
          tap(instructors => {
            const rows = Array.isArray(instructors) ? instructors as InstructorInfo[] : [];
            this.carouselSource = this.shuffle(excludePartnerArtifacts(rows));
          })
        )
        .subscribe();
    } else {
      this.carouselSource = [];
    }
  }

  shuffle(array: any[]): any[] {
    let currentIndex = array.length,  randomIndex;
  
    // While there remain elements to shuffle.
    while (currentIndex != 0) {
  
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
  
      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
  
    return array;
  }

  ngOnDestroy(): void {
    this._unsubscribe.next(null);
    this._unsubscribe.complete();
  }

}
